<template>
  <div class="result-list">
    <div class="cards" :style="gridConfig">
      <EcommerceFilterCard
        v-for="product of shownFilteredProducts"
        :key="product.id"
        :product="product"
      ></EcommerceFilterCard>
    </div>
    <div class="cards-mobile">
      <EcommerceFilterCard
        v-for="product of shownFilteredProducts"
        :key="product.id"
        :product="product"
      ></EcommerceFilterCard>
    </div>
    <div
      v-if="shownFilteredProducts.length < filteredProducts.length && !isSeeingAll"
      class="see-all"
      @click="$store.dispatch('updateIsSeeingAll', true)"
    >
      See All
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import EcommerceFilterCard from './Card';

export default {
  name: 'EcommerceFilterResultList',
  components: {
    EcommerceFilterCard,
  },
  props: {
    numberOfRows: {
      type: Number,
      required: true,
    },
    numberOfColumns: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState({
      filteredProducts: (state) => state.ecommerce.filteredProducts,
      isSeeingAll: (state) => state.ecommerce.isSeeingAll,
    }),
    shownFilteredProducts: function () {
      if (this.isSeeingAll) {
        return this.filteredProducts;
      }

      return [...this.filteredProducts].splice(0, this.numberOfRows * this.numberOfColumns);
    },
    gridConfig: function () {
      const templateColumns = new Array(this.numberOfColumns).fill('1fr').join(' ');
      return {
        'grid-template-columns': templateColumns,
      };
    },
  },
};
</script>

<style scoped>
.result-list {
  margin-top: 20px;
}

.cards {
  display: grid;
  justify-content: space-between;
  grid-gap: 20px;
}

.cards-mobile {
  display: none;
}

@media only screen and (max-width: 40em) {
  .cards {
    display: none;
  }
  
  .cards-mobile {
    display: grid;
    justify-content: space-between;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
}

.see-all {
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// ResultList.vue?c592bd02